import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function insertDecimalAfterTwoDigits(value: string): string {
  const t = value.trim().replace(',', '.');
  if (t.includes('.')) return t;
  const neg = t.startsWith('-');
  const digits = (neg ? t.slice(1) : t).replace(/\D/g, '');
  if (digits.length < 3) return t;
  return (neg ? '-' : '') + digits.slice(0, 2) + '.' + digits.slice(2);
}

export function coordinateNumberToInputString(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) return '';
  return String(value);
}

export function toGeoCoordinateNumber(value: unknown): number {
  if (typeof value === 'number') return value;
  return parseFloat(String(value ?? '').trim());
}

export function parseGeoCoordinate(value: unknown): number {
  return toGeoCoordinateNumber(value);
}

export function latitudeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v === '' || v == null) return null;
    const n = toGeoCoordinateNumber(v);
    if (Number.isNaN(n) || !Number.isFinite(n)) return { latitudeInvalid: true };
    if (n < -90 || n > 90) return { latitudeRange: true };
    return null;
  };
}

export function longitudeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = control.value;
    if (v === '' || v == null) return null;
    const n = toGeoCoordinateNumber(v);
    if (Number.isNaN(n) || !Number.isFinite(n)) return { longitudeInvalid: true };
    if (n < -180 || n > 180) return { longitudeRange: true };
    return null;
  };
}
